import ApiOpsDashboard from './apiOpsDashboard';

export default ApiOpsDashboard;